/**
 * Get the price based on the selected country
 * @param {Object} product - Product object
 * @param {string} country - Country ID (egypt or saudi)
 * @returns {number} - Price for the selected country
 */
export const getPriceByCountry = (product, country) => {
  if (!product) return 0;

  if (country === "saudi") {
    return product.price_ar || product.price;
  }
  // Default to Egypt (price_eg)
  return product.price_eg || product.price;
};

/**
 * Get the discounted price based on country and discount
 * @param {Object} product - Product object
 * @param {string} country - Country ID (egypt or saudi)
 * @returns {number} - Discounted price for the selected country
 */
export const getDiscountedPriceByCountry = (product, country) => {
  if (!product) return 0;

  const price = getPriceByCountry(product, country);
  const discount = getDiscountByCountry(product, country);

  return price - (price * discount) / 100;
};

/**
 * Format price with currency symbol
 * @param {number} price - Price value
 * @param {string} country - Country ID (egypt or saudi)
 * @returns {string} - Formatted price with currency
 */
export const formatPriceWithCurrency = (price, country) => {
  const currency = getCurrencyNameByCountry(country);
  return `${Number(price)?.toFixed(2)} ${currency}`;
};

/**
 * Get the phone number based on the selected country
 * @param {Object} storeInfo - Store info object
 * @param {string} country - Country ID (egypt or saudi)
 * @returns {string} - Phone number for the selected country
 */
export const getPhoneByCountry = (storeInfo, country) => {
  if (!storeInfo) return "";

  if (country === "saudi") {
    return storeInfo.phone_ar || storeInfo.phone;
  }
  // Default to Egypt (phone_eg)
  return storeInfo.phone_eg || storeInfo.phone;
};

/**
 * Get the discount based on the selected country
 * @param {Object} product - Product object
 * @param {string} country - Country ID (egypt or saudi)
 * @returns {number} - Discount percentage for the selected country
 */
export const getDiscountByCountry = (product, country) => {
  if (!product) return 0;

  if (country === "saudi") {
    return product.discount_ar || product.discount;
  }
  // Default to Egypt (discount_eg)
  return product.discount_eg || product.discount;
};

/**
 * Get the currency code based on the selected country
 * @param {string} country - Country ID (egypt or saudi)
 * @returns {string} - Currency code for the selected country
 */
export const getCurrencyByCountry = (country) => {
  if (country === "saudi") {
    return "SAR"; // Saudi Riyal
  }
  // Default to Egypt
  return "LE"; // Egyptian Pound
};

/**
 * Get the currency name based on the selected country
 * @param {string} country - Country ID (egypt or saudi)
 * @returns {string} - Currency name for the selected country
 */
export const getCurrencyNameByCountry = (country) => {
  if (country === "saudi") {
    return "ريال"; // Arabic for Riyal
  }
  // Default to Egypt
  return "جنية"; // Arabic for Pound
};
